import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import {initDeepLinkData} from "../../utilities/sdk-doc-utils";
import EntityHandler from "js/utilities/entity-handler"
import FontAwesome from "react-fontawesome";

export default React.createClass({
  render(){
    if (this.props.processing){
      return <FontAwesome name="circle-o-notch" className="form-icon fa-spin processing" />
    }
    else if (!this.props.checked){
      if (this.props.disabled){
        return <FontAwesome name="circle-o" className="form-icon not-checked disabled"/>
      }
      return <FontAwesome name="circle-o" className="form-icon not-checked" onClick={this.props.onClick} />
    }
    else if (this.props.checked){
      if (this.props.disabled){
        return <FontAwesome name="check-circle" className="form-icon checked disabled" />
      }
      return <FontAwesome name="check-circle" className="form-icon checked" onClick={this.props.onClick} />
    }
  },
});


// WEBPACK FOOTER //
// ./src/js/components/account/account-form-checkbox.jsx